/* Opt-in collection/LP offer summary. Uses shared promotion resolution; no cart writes. */
(() => {
  if (customElements.get('maf-grid-campaign-offer')) return;
  class GridCampaignOffer extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.refresh = () => {
        const headlineOnly = this.hasAttribute('data-headline-only');
        const badge = headlineOnly ? null : this.closest('.kit-offer')?.querySelector('[data-grid-campaign-badge]');
        this.hidden = true;
        if (badge) badge.hidden = true;
        try {
          const data = JSON.parse(this.querySelector('[data-grid-promotion]').textContent);
          const selection = JSON.parse(this.querySelector('[data-grid-selection]').textContent);
          const api = window.MAFCommerce;
          const promotion = api && api.resolvePromotion(data);
          const productId = String(selection.productId || '').split('/').pop();
          if (!promotion || !promotion.eligibleProducts.has(productId)) return;
          const lines = selection.items;
          if (!Array.isArray(lines) || !lines.length || lines.some(line => !Number.isSafeInteger(line.quantity) || line.quantity < 1 || !Number.isSafeInteger(line.price) || line.price < 0)) return;
          const quantity = api.count(promotion, lines);
          const subtotal = lines.reduce((total, line) => total + line.quantity * line.price, 0);
          if (!Number.isSafeInteger(subtotal)) return;
          const money = cents => new Intl.NumberFormat(data.locale || 'en-US', {style:'currency',currency:data.currency}).format(cents / 100);
          const rewards = [];
          const selected = [];
          if (promotion.cash) {
            const gift = promotion.schedule.gift;
            const availableGift = (gift.products || []).find(product => product.available === true && product.variantCount === 1);
            if (availableGift) {
              const name = availableGift.name || 'gift';
              rewards.push(gift.minimum + '+ kits: Free ' + name);
              if (quantity >= Number(gift.minimum)) selected.push('Free ' + name);
            }
            const cash = [...promotion.tiers].filter(tier => tier.fixed > 0).sort((a,b) => a.subtotal - b.subtotal);
            for (const tier of cash) rewards.push(money(tier.fixed) + ' off orders ' + money(tier.subtotal) + '+');
            const savings = api.cashReward(promotion, subtotal);
            if (savings > 0) selected.push(money(savings).replace(/([.,]00)(?=\D*$)/, '') + ' off');
          } else {
            for (const tier of promotion.tiers.filter(tier => tier.percent > 0)) rewards.push(tier.minimum + '+ kits: Save ' + tier.percent + '%');
            const percent = api.percent(promotion, quantity);
            if (percent > 0) selected.push('Save ' + percent + '%');
          }
          if (!rewards.length) return;
          const view = this.querySelector('[data-grid-offer-view]');
          view.replaceChildren();
          if (headlineOnly) {
            if (selected.length) { view.textContent = selected.join(' + '); this.hidden = false; }
            return;
          }
          const name = document.createElement('strong');
          name.className = 'maf-grid-offer__name';
          name.textContent = promotion.schedule.name || 'Current offer';
          view.append(name);
          const list = document.createElement('ul');
          list.className = 'maf-grid-offer__rewards';
          for (const text of rewards) {
            const item = document.createElement('li');
            item.className = 'maf-grid-offer__reward';
            item.textContent = text;
            list.append(item);
          }
          view.append(list);
          if (badge && selected.length) { badge.textContent = selected.join(' + '); badge.hidden = false; }
          this.hidden = false;
        } catch (_) { /* Invalid/unavailable offers remain hidden; no stale reward claim. */ }
      };
      this.refresh();
      this.timer = setInterval(this.refresh, 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.bound = false; }
  }
  customElements.define('maf-grid-campaign-offer', GridCampaignOffer);
})();
